import axiosNextGen from '../../../config/axios-nextgen';

/**
 * Exam API Service (Next-Gen)
 */

/**
 * Update the same-day provider visit flag on an exam
 * @param {string} patientExamId
 * @param {boolean} sameDayProviderVisitYn
 * @returns {Promise<void>}
 */
export async function updateSameDayProviderVisit(patientExamId, sameDayProviderVisitYn) {
    await axiosNextGen.patch('/api/exams/same-day-provider-visit', {
        patientExamId,
        sameDayProviderVisitYn
    });
}
